import styled from 'styled-components';

const H5 = styled.h5.attrs({
  className: `
    text-sm
    font-semibold
    text-center
    text-gray-600
    
    dark:text-gray-300
  `,
})``;

export default H5;
